module.exports = __webpack_public_path__ + "img/corp-customization-side-th.0bb1b6b1.svg";